module.exports = __webpack_public_path__ + "img/1.0474d48f.png";